/**
 * We are registering theme on WINDOW to prevent clash with Apps that are being built
 * How we access theme is in global store getters
 * We are also using only baseComponentsVariants API to style our components with
 * Tailwind default classes that are hardcoded in the Studio Codebase
 */

/* eslint-disable */
export default () => {
	window.COVERGO_STUDIO_THEME = {
		baseComponentsVariants: {
			JInputText: {
				default: {
					description: "You can describe what it is",
					el: {
						root:
							"s-bg-gray-50 s-text-black s-p-2 s-rounded s-border s-border-gray-300 s-appearance-none s-w-full s-h-10 s-placeholder-gray-500 focus:s-outline-none focus:s-shadow-outline"
					}
				},
				disabled: {
					description: "You can describe what it is",
					el: {
						root:
							"s-bg-gray-50 s-text-black s-p-2 s-rounded s-border s-border-gray-300 s-appearance-none s-w-full s-h-10 s-placeholder-gray-500 s-pointer-events-none"
					}
				},
				ghost: {
					el: {
						root: "s-appearance-none focus:s-outline-none"
					}
				}
			},
			JInputLongText: {
				default: {
					el: {
						root:
							"s-bg-gray-50 s-text-black s-p-2 s-rounded s-border s-border-gray-300 s-appearance-none s-w-full min-s-h-10 s-placeholder-gray-500 focus:s-outline-none focus:s-shadow-outline"
					}
				},
				disabled: {
					el: {
						root:
							"s-bg-gray-50 s-text-black s-p-2 s-rounded s-border s-border-gray-300 s-appearance-none s-w-full min-s-h-10 s-placeholder-gray-500 s-pointer-events-none"
					}
				}
			},
			JInputNumber: {
				default: {
					description: "You can describe what it is",
					el: {
						root:
							"s-bg-gray-50 s-text-black s-p-2 s-rounded s-border s-border-gray-300 s-appearance-none s-w-full s-h-10 s-placeholder-gray-500 focus:s-outline-none focus:s-shadow-outline"
					}
				},
				disabled: {
					description: "You can describe what it is",
					el: {
						root:
							"s-bg-gray-50 s-text-black s-p-2 s-rounded s-border s-border-gray-300 s-appearance-none s-w-full s-h-10 s-placeholder-gray-500 s-pointer-events-none"
					}
				}
			},
			JInputNumberStepper: {
				default: {
					el: {
						root: "flex flex-auto",
						button:
							"flex items-center justify-center s-bg-gray-50 hover:bg-c2 hover:s-text-white s-text-black s-rounded cursor-pointer s-h-10 s-w-10 select-none focus:s-outline-none focus:s-shadow-outline",
						buttonDisabled:
							"flex items-center justify-center s-bg-gray-50 s-text-black s-rounded cursor-not-allowed  s-h-10 s-w-10 select-none focus:s-outline-none",
						counter: "flex items-center justify-center s-text-black s-h-10 s-w-16 select-none"
					}
				},
				disabled: {
					el: {
						root: "flex flex-auto s-pointer-events-none",
						button:
							"flex items-center justify-center s-bg-gray-50 hover:bg-c2 hover:s-text-white s-text-black s-rounded cursor-pointer s-h-10 s-w-10 select-none focus:s-outline-none focus:s-shadow-outline",
						buttonDisabled:
							"flex items-center justify-center s-bg-gray-50 s-text-black s-rounded cursor-not-allowed  s-h-10 s-w-10 select-none focus:s-outline-none",
						counter: "flex items-center justify-center s-text-black s-h-10 s-w-16 select-none"
					}
				}
			},
			JRadios: {
				default: {
					el: {
						root: "s-flex s-flex-auto s-select-none",
						item:
							"s-flex s-items-center s-px-3 s-bg-gray-100 s-text-black s-rounded s-border s-border-gray-300 s-cursor-pointer s-mr-2 last:s-mr-0 s-h-10 focus:s-outline-none focus:s-shadow-outline",
						itemSelected:
							"s-flex s-items-center s-px-3 s-text-white s-rounded s-border s-bg-indigo-600 s-border-indigo-600 s-cursor-pointer s-mr-2 s-h-10 focus:s-outline-none focus:s-shadow-outline"
					}
				}
			},
			JCalendar: {
				default: {
					el: {
						calendar: "s-w-64 s-bg-white s-px-2 s-border-gray-300 s-border s-rounded-lg s-my-2 s-pb-3",
						navigation: "s-py-4 s-flex s-justify-between s-items-center",
						changeMonthButtons:
							"s-text-gray-200 hover:s-text-gray-600 s-cursor-pointer s-transition-all s-duration-200 s-ease-in-out s-px-3",
						monthYearSelect: "s-text-sm focus:s-outline-none",
						weekdaysWrapper:
							"s-flex s-justify-around s-mb-3 s-pb-1 s-border-b-2 s-border-gray-200 s-select-none s-text-sm s-font-semibold",
						weekday: "",
						datesWrapper: "s-flex s-flex-wrap s-justify-between",
						selectedDate: "s-bg-indigo-100 s-rounded-full s-font-semibold s-text-gray-800 s-py-1 focus:s-outline-none",
						disabledDate: "s-text-gray-200",
						dateOfActiveMonth: "s-bg-white hover:s-bg-gray-50 s-rounded-full focus:s-outline-none s-py-1",
						date:
							"s-text-gray-300 s-rounded-full hover:s-text-gray-600 hover:s-bg-gray-50 focus:s-outline-none s-transition-all s-duration-200 s-ease-in-out"
					}
				},
				disabled: {
					el: {
						calendar: "s-w-64 s-bg-gray-100 s-px-2 s-border-gray-300 s-border s-rounded-lg s-my-2 s-pb-3",
						navigation: "s-py-4 s-flex s-justify-between s-items-center",
						changeMonthButtons: "s-text-gray-400 s-cursor-pointer s-pointer-events-none s-px-3",
						monthYearSelect: "s-text-sm s-text-gray-400 s-pointer-events-none focus:s-outline-none",
						weekdaysWrapper:
							"s-flex s-justify-around s-mb-3 s-pb-1 s-border-b-2 s-border-gray-200 s-select-none s-text-sm s-font-semibold",
						weekday: "s-text-gray-400",
						datesWrapper: "s-flex s-flex-wrap s-justify-between",
						selectedDate: "s-text-gray-400 s-rounded-full s-font-semibold s-py-1 focus:s-outline-none",
						disabledDate: "s-text-gray-400 focus:s-outline-none",
						dateOfActiveMonth: "s-text-gray-400 s-rounded-full s-py-1 focus:s-outline-none",
						date: "s-text-gray-300 s-rounded-full focus:s-outline-none"
					}
				}
			},
			JCheckbox: {
				default: {
					el: {
						root: "s-inline-block s-cursor-pointer",
						hiddenInput: "s-w-0 s-h-0 s-opacity-0 s-absolute",
						checkbox:
							"flex items-center s-w-6 s-h-6 s-rounded s-border s-border-pink-400 cursor-pointer focus:s-outline-none focus:s-shadow-outline",
						checkboxChecked:
							"s-text-pink-500 flex items-center s-w-6 s-h-6 s-rounded s-bg-pink-100 s-border s-border-pink-400 cursor-pointer focus:s-outline-none focus:s-shadow-outline"
					},
					assets: {
						iconChecked: "&#x2713;",
						iconIndeterminate: "&#8259;"
					}
				},
				disabled: {
					el: {
						root: "s-inline-block s-cursor-pointer",
						hiddenInput: "s-w-0 s-h-0 s-opacity-0 s-absolute",
						checkbox:
							"s-pointer-events-none s-cursor-not-allowed  flex items-center s-w-6 s-h-6 s-rounded s-border s-border-gray-300 cursor-pointer focus:s-outline-none focus:s-shadow-outline",
						checkboxChecked:
							"s-pointer-events-none s-cursor-not-allowed  s-text-gray-500 flex items-center s-w-6 s-h-6 s-rounded s-bg-white s-border s-border-gray-300 cursor-pointer focus:s-outline-none focus:s-shadow-outline"
					},
					assets: {
						iconChecked: "&#x2713;",
						iconIndeterminate: "&#8259;"
					}
				},
				rounded: {
					el: {
						root: "s-inline-block s-cursor-pointer",
						hiddenInput: "s-w-0 s-h-0 s-opacity-0 s-absolute",
						checkbox:
							"flex items-center s-w-6 s-h-6 s-rounded-full s-border s-border-pink-400 cursor-pointer focus:s-outline-none focus:s-shadow-outline",
						checkboxChecked:
							"s-text-pink-500 flex items-center s-w-6 s-h-6 s-rounded-full s-bg-pink-100 s-border s-border-pink-400 cursor-pointer focus:s-outline-none focus:s-shadow-outline"
					},
					assets: {
						iconChecked: "&#x2713;",
						iconIndeterminate: "&#8259;"
					}
				}
			},
			JCheckboxGroup: {
				default: {
					el: {
						root: "flex flex-auto select-none pointer-events-auto ",
						item:
							"flex items-center px-3 s-bg-white s-text-black s-rounded s-border s-border-gray-300 cursor-pointer mr-2 mt-2 last:mr-0 s-h-10 focus:s-outline-none focus:s-shadow-outline",
						itemSelected:
							"flex items-center px-3 bg-c2 s-text-white s-rounded s-border s-border-c2 cursor-pointer mr-2 mt-2 s-h-10 focus:s-outline-none focus:s-shadow-outline"
					}
				},
				disabled: {
					el: {
						root: "flex flex-auto select-none pointer-events-auto s-pointer-events-none",
						item:
							"flex items-center px-3 s-bg-white s-text-black s-rounded s-border s-border-gray-300 cursor-pointer mr-2 mt-2 last:mr-0 s-h-10 focus:s-outline-none focus:s-shadow-outline",
						itemSelected:
							"flex items-center px-3 bg-c2 s-text-white s-rounded s-border s-border-c2 cursor-pointer mr-2 mt-2 s-h-10 focus:s-outline-none focus:s-shadow-outline"
					}
				},
				templates: {
					el: {
						root: "s-text-sm s-flex s-flex-auto s-select-none s-mb-2",
						item:
							"s-flex s-items-center s-font-semibold s-px-3 s-bg-white s-text-cBlack s-rounded s-border s-border-c0 s-cursor-pointer s-mr-2 s-last:mr-0 s-h-9 focus:s-outline-none s-text-sm",
						itemSelected:
							"s-flex s-items-center s-font-semibold s-px-3 s-bg-indigo-100 s-text-indigo-600 s-rounded s-border s-border-c0 s-cursor-pointer s-mr-2 s-h-9 s-focus:outline-none s-text-sm"
					}
				}
			},
			JToggle: {
				default: {
					el: {
						sliderTrue:
							"s-w-12 s-h-6 s-rounded-full s-shadow s-inline-block s-cursor-pointer s-bg-green-400 focus:s-outline-none focus:s-shadow-outline",
						sliderFalse:
							"s-w-12 s-h-6 s-rounded-full s-shadow s-inline-block s-cursor-pointer s-bg-gray-700 focus:s-outline-none focus:s-shadow-outline",
						switchTrue: "s-w-6 s-h-6 s-bg-white s-rounded-full s-shadow",
						switchFalse: "s-w-6 s-h-6 s-bg-white s-rounded-full s-shadow"
					}
				},
				disabled: {
					el: {
						sliderTrue:
							"s-w-12 s-h-6 s-rounded-full s-shadow s-inline-block s-cursor-pointer s-bg-green-400 focus:s-outline-none focus:s-shadow-outline s-pointer-events-none",
						sliderFalse:
							"s-w-12 s-h-6 s-rounded-full s-shadow s-inline-block s-cursor-pointer s-bg-gray-700 focus:s-outline-none focus:s-shadow-outline s-pointer-events-none",
						switchTrue: "s-w-6 s-h-6 s-bg-white s-rounded-full s-shadow s-pointer-events-none",
						switchFalse: "s-w-6 s-h-6 s-bg-white s-rounded-full s-shadow s-pointer-events-none"
					}
				}
			},
			JSelect: {
				default: {
					el: {
						root: "s-inline-block s-relative s-w-full s-bg-transparent s-h-10",
						select:
							"s-block s-appearance-none s-w-full s-bg-gray-50 s-border  s-rounded s-border-gray-300 s-px-2 s-py-2 s-pr-8  s-leading-tight focus:s-outline-none focus:s-shadow-outline",
						iconRoot: "s-pointer-events-none s-absolute s-inset-y-0 s-right-0 s-flex s-items-center s-px-3 s-text-black",
						icon: "s-fill-current s-h-3 s-w-3"
					}
				},
				disabled: {
					el: {
						root: "s-inline-block s-relative s-w-full s-bg-white s-pointer-events-none",
						select:
							"s-block s-appearance-none s-w-full s-border s-rounded s-border-gray-300 s-px-2 s-py-2 s-pr-8 s-leading-tight focus:s-outline-none focus:s-shadow-outline",
						iconRoot: "s-pointer-events-none s-absolute s-inset-y-0 s-right-0 s-flex s-items-center s-text-black",
						icon: "s-fill-current s-h-2 s-w-2"
					}
				},
				dark: {
					el: {
						root: "s-inline-block s-relative s-w-full s-bg-gray-800 s-h-10 s-rounded-lg s-shadow-md",
						select:
							"s-bg-gray-800 s-text-gray-300 s-px-3 s-cursor-pointer s-h-full s-rounded-lg s-appearance-none s-border s-border-gray-900 s-w-full s-placeholder-gray-600 focus:s-outline-none focus:s-shadow-outline",
						iconRoot: "s-pointer-events-none s-absolute s-inset-y-0 s-right-0 s-flex s-items-center s-px-3 s-text-gray-400",
						icon: "s-fill-current s-h-2 s-w-2"
					}
				},
				ghost: {
					el: {
						root: "s-inline-block s-relative s-w-full",
						select: "s-cursor-pointer s-bg-transparent s-appearance-none s-placeholder-gray-600 focus:s-outline-none",
						iconRoot: "s-pointer-events-none s-absolute s-inset-y-0 s-right-0 s-flex s-items-center s-px-3",
						icon: "s-fill-current s-h-2 s-w-2"
					}
				}
			},
			JDatePicker: {
				default: {
					el: {
						root: "s-w-full",
						input:
							"s-bg-white s-text-black s-p-2 s-rounded s-border s-border-gray-300 s-appearance-none s-w-full s-h-10 s-placeholder-gray-500 focus:s-outline-none focus:s-shadow-outline"
					}
				},
				disabled: {
					el: {
						root: "s-w-full s-pointer-events-none",
						input:
							"s-bg-white s-text-black s-p-2 s-rounded s-border s-border-gray-300 s-appearance-none s-w-full s-h-10 s-placeholder-gray-500 focus:s-outline-none focus:s-shadow-outline"
					}
				}
			},
			JModalSimple: {
				small: {
					el: {
						root: "s-m-auto s-w-full s-max-w-xl s-overflos-w-y-auto"
					}
				},
				default: {
					el: {
						root: "s-m-auto s-w-full s-max-w-2xl s-overflos-w-y-auto"
					}
				},
				large: {
					el: {
						root: "s-m-auto s-w-full s-max-w-5xl s-overflos-w-y-auto"
					}
				}
			},
			JMessage: {
				default: {
					el: {
						root: "s-w-full s-fixed s-bottom-0 s-left-0 s-p-4 s-pointer-events-none",
						messageSuccess:
							"s-w-full md:s-w-3/12 s-p-5 s-rounded-lg s-shadow s-inline-block s-cursor-pointer s-bg-green-500 s-text-white s-mb-2 focus:s-outline-none focus:s-shadow-outline s-relative s-pointer-events-auto",
						messageError:
							"s-w-full md:s-w-3/12 s-p-5 s-rounded-lg s-shadow s-inline-block s-cursor-pointer s-bg-red-700 s-text-white s-mb-2 focus:s-outline-none focus:s-shadow-outline s-relative s-pointer-events-auto",
						messageWarning:
							"s-w-full md:s-w-3/12 s-p-5 s-text-black s-rounded-lg s-shadow s-inline-block s-cursor-pointer s-bg-yellow-500 s-text-white s-mb-2 focus:s-outline-none focus:s-shadow-outline s-relative s-pointer-events-auto",
						messageNeutral:
							"s-w-full md:s-w-3/12 s-p-5 s-text-black s-rounded-lg s-shadow s-inline-block s-cursor-pointer s-bg-white s-mb-2 focus:s-outline-none focus:s-shadow-outline s-relative s-pointer-events-auto",
						closeIcon:
							"s-rounded s-w-6 s-h-6 s-flex s-justify-center s-align-center s-opacity-50 hover:s-opacity-100 s-text-white s-absolute s-top-0 s-right-0 s-mr-1 s-mt-1",
						transition: {
							enter: "s-opacity-0",
							leave: "s-opacity-0",
							enterActive: "s-transition-all s-duration-1000 s-ease-in-out",
							leaveActive: "s-transition-all s-duration-1000 s-ease-in-out"
						}
					}
				}
			},
			JInputDateOfBirth: {
				default: {
					el: {
						root: "s-w-full flex flex-wrap bg-c0",
						day: "s-w-full flex-grow md:s-w-auto mb-2 md:mb-0 md:mr-2 focus:s-outline-none focus:s-shadow-outline",
						month: "s-w-full flex-grow md:s-w-auto mb-2 md:mb-0 md:mr-2 focus:s-outline-none focus:s-shadow-outline",
						year: "s-w-full flex-grow md:s-w-auto mb-2 md:mb-0 focus:s-outline-none focus:s-shadow-outline"
					},
					componentInstanceVariants: {
						daySelect: "default",
						monthSelect: "default",
						yearSelect: "default"
					}
				},
				disabled: {
					el: {
						root: "s-w-full flex flex-wrap bg-c0 s-pointer-events-none",
						day: "s-w-full flex-grow md:s-w-auto mb-2 md:mb-0 md:mr-2 s-pointer-events-none",
						month: "s-w-full flex-grow md:s-w-auto mb-2 md:mb-0 md:mr-2 s-pointer-events-none",
						year: "s-w-full flex-grow md:s-w-auto mb-2 md:mb-0 s-pointer-events-none"
					},
					componentInstanceVariants: {
						daySelect: "disabled",
						monthSelect: "disabled",
						yearSelect: "disabled"
					}
				}
			},
			JButton: {
				"default-xs": {
					el: {
						root:
							"s-inline-flex s-items-center s-px-2 s-border s-border-transparent s-text-xs s-leading-relaxed s-font-medium s-rounded-md s-text-white s-bg-indigo-600 hover:s-bg-indigo-500 focus:s-outline-none focus:s-border-indigo-700 focus:s-shadow-outline-indigo active:s-bg-indigo-700 s-transition s-ease-in-out s-duration-150 s-cursor-pointer"
					}
				},
				"default-sm": {
					el: {
						root:
							"s-inline-flex s-items-center s-px-3 s-py-1 s-border s-border-transparent s-text-xs  s-leading-relaxed s-font-medium s-rounded-md s-text-white s-bg-indigo-600 hover:s-bg-indigo-500 focus:s-outline-none focus:s-border-indigo-700 focus:s-shadow-outline-indigo active:s-bg-indigo-700 s-transition s-ease-in-out s-duration-150 s-cursor-pointer"
					}
				},
				default: {
					el: {
						root:
							"s-inline-flex s-items-center s-px-4 s-py-2 s-border s-border-transparent s-text-base s-leading-relaxed s-font-medium s-rounded-md s-text-white s-bg-indigo-600 hover:s-bg-indigo-500 focus:s-outline-none focus:s-border-indigo-700 focus:s-shadow-outline-indigo active:s-bg-indigo-700 s-transition s-ease-in-out s-duration-150 s-cursor-pointer"
					}
				},
				"default-lg": {
					el: {
						root:
							"s-inline-flex s-items-center s-px-5 s-py-2 s-border s-border-transparent s-text-xl  s-leading-relaxed s-font-medium s-rounded-lg s-text-white s-bg-indigo-600 hover:s-bg-indigo-500 focus:s-outline-none focus:s-border-indigo-700 focus:s-shadow-outline-indigo active:s-bg-indigo-700 s-transition s-ease-in-out s-duration-150 s-cursor-pointer"
					}
				},
				"default-xl": {
					el: {
						root:
							"s-inline-flex s-items-center s-px-6 s-py-2 s-border s-border-transparent s-text-2xl  s-leading-relaxed s-font-medium s-rounded-lg s-text-white s-bg-indigo-600 hover:s-bg-indigo-500 focus:s-outline-none focus:s-border-indigo-700 focus:s-shadow-outline-indigo active:s-bg-indigo-700 s-transition s-ease-in-out s-duration-150 s-cursor-pointer"
					}
				},
				"default-light-xs": {
					el: {
						root:
							"s-inline-flex s-items-center s-px-2 s-border s-border-transparent s-text-xs s-leading-relaxed s-font-medium s-rounded-md s-text-indigo-700 s-bg-indigo-100 hover:s-text-indigo-600 focus:s-outline-none focus:s-border-indigo-200 focus:s-shadow-outline-indigo active:s-bg-indigo-700 s-transition s-ease-in-out s-duration-150 s-cursor-pointer"
					}
				},
				"default-light-sm": {
					el: {
						root:
							"s-inline-flex s-items-center s-px-3 s-py-1 s-border s-border-transparent s-text-xs  s-leading-relaxed s-font-medium s-rounded-md s-text-indigo-700 s-bg-indigo-100 hover:s-text-indigo-600 focus:s-outline-none focus:s-border-indigo-200 focus:s-shadow-outline-indigo active:s-bg-indigo-700 s-transition s-ease-in-out s-duration-150 s-cursor-pointer"
					}
				},
				"default-light": {
					el: {
						root:
							"s-inline-flex s-items-center s-px-4 s-py-2 s-border s-border-transparent s-text-base s-leading-relaxed s-font-medium s-rounded-md s-text-indigo-700 s-bg-indigo-100 hover:s-text-indigo-600 focus:s-outline-none focus:s-border-indigo-200 focus:s-shadow-outline-indigo active:s-bg-indigo-700 s-transition s-ease-in-out s-duration-150 s-cursor-pointer"
					}
				},
				"default-light-lg": {
					el: {
						root:
							"s-inline-flex s-items-center s-px-5 s-py-2 s-border s-border-transparent s-text-xl  s-leading-relaxed s-font-medium s-rounded-lg s-text-indigo-700 s-bg-indigo-100 hover:s-text-indigo-600 focus:s-outline-none focus:s-border-indigo-200 focus:s-shadow-outline-indigo active:s-bg-indigo-700 s-transition s-ease-in-out s-duration-150 s-cursor-pointer"
					}
				},
				"default-light-xl": {
					el: {
						root:
							"s-inline-flex s-items-center s-px-6 s-py-2 s-border s-border-transparent s-text-2xl  s-leading-relaxed s-font-medium s-rounded-lg s-text-indigo-700 s-bg-indigo-100 hover:s-text-indigo-600 focus:s-outline-none focus:s-border-indigo-200 focus:s-shadow-outline-indigo active:s-bg-indigo-700 s-transition s-ease-in-out s-duration-150 s-cursor-pointer"
					}
				},
				"white-xs": {
					el: {
						root:
							"s-inline-flex s-items-center s-px-2 s-border s-border-gray-300 s-text-xs s-leading-relaxed s-font-medium s-rounded-md s-text-gray-700 s-bg-white hover:s-text-gray-600 focus:s-outline-none focus:s-border-gray-300 focus:s-shadow-outline-indigo active:s-bg-gray-300 s-transition s-ease-in-out s-duration-150 s-cursor-pointer"
					}
				},
				"white-sm": {
					el: {
						root:
							"s-inline-flex s-items-center s-px-3 s-py-1 s-border s-border-gray-300 s-text-xs  s-leading-relaxed s-font-medium s-rounded-md s-text-gray-700 s-bg-white hover:s-text-gray-600 focus:s-outline-none focus:s-border-gray-300 focus:s-shadow-outline-indigo active:s-bg-gray-300 s-transition s-ease-in-out s-duration-150 s-cursor-pointer"
					}
				},
				white: {
					el: {
						root:
							"s-inline-flex s-items-center s-px-4 s-py-2 s-border s-border-gray-300 s-text-base s-leading-relaxed s-font-medium s-rounded-md s-text-gray-700 s-bg-white hover:s-text-gray-600 focus:s-outline-none focus:s-border-gray-300 focus:s-shadow-outline-indigo active:s-bg-gray-300 s-transition s-ease-in-out s-duration-150 s-cursor-pointer"
					}
				},
				"white-lg": {
					el: {
						root:
							"s-inline-flex s-items-center s-px-5 s-py-2 s-border s-border-gray-300 s-text-xl  s-leading-relaxed s-font-medium s-rounded-lg s-text-gray-700 s-bg-white hover:s-text-gray-600 focus:s-outline-none focus:s-border-gray-300 focus:s-shadow-outline-indigo active:s-bg-gray-300 s-transition s-ease-in-out s-duration-150 s-cursor-pointer"
					}
				},
				"white-xl": {
					el: {
						root:
							"s-inline-flex s-items-center s-px-6 s-py-2 s-border s-border-gray-300 s-text-2xl  s-leading-relaxed s-font-medium s-rounded-lg s-text-gray-700 s-bg-white hover:s-text-gray-600 focus:s-outline-none focus:s-border-gray-300 focus:s-shadow-outline-indigo active:s-bg-gray-300 s-transition s-ease-in-out s-duration-150 s-cursor-pointer"
					}
				},
				"error-xs": {
					el: {
						root:
							"s-inline-flex s-items-center s-px-2 s-border s-border-transparent s-text-xs s-leading-relaxed s-font-medium s-rounded-md s-text-white s-bg-red-600 hover:s-bg-red-500 focus:s-outline-none focus:s-border-red-700 focus:s-shadow-outline-indigo active:s-bg-red-700 s-transition s-ease-in-out s-duration-150 s-cursor-pointer"
					}
				},
				"error-sm": {
					el: {
						root:
							"s-inline-flex s-items-center s-px-3 s-py-1 s-border s-border-transparent s-text-xs  s-leading-relaxed s-font-medium s-rounded-md s-text-white s-bg-red-600 hover:s-bg-red-500 focus:s-outline-none focus:s-border-red-700 focus:s-shadow-outline-indigo active:s-bg-red-700 s-transition s-ease-in-out s-duration-150 s-cursor-pointer"
					}
				},
				error: {
					el: {
						root:
							"s-inline-flex s-items-center s-px-4 s-py-2 s-border s-border-transparent s-text-base s-leading-relaxed s-font-medium s-rounded-md s-text-white s-bg-red-600 hover:s-bg-red-500 focus:s-outline-none focus:s-border-red-700 focus:s-shadow-outline-indigo active:s-bg-red-700 s-transition s-ease-in-out s-duration-150 s-cursor-pointer"
					}
				},
				"error-lg": {
					el: {
						root:
							"s-inline-flex s-items-center s-px-5 s-py-2 s-border s-border-transparent s-text-xl  s-leading-relaxed s-font-medium s-rounded-lg s-text-white s-bg-red-600 hover:s-bg-red-500 focus:s-outline-none focus:s-border-red-700 focus:s-shadow-outline-indigo active:s-bg-red-700 s-transition s-ease-in-out s-duration-150 s-cursor-pointer"
					}
				},
				"error-xl": {
					el: {
						root:
							"s-inline-flex s-items-center s-px-6 s-py-2 s-border s-border-transparent s-text-2xl  s-leading-relaxed s-font-medium s-rounded-lg s-text-white s-bg-red-600 hover:s-bg-red-500 focus:s-outline-none focus:s-border-red-700 focus:s-shadow-outline-indigo active:s-bg-red-700 s-transition s-ease-in-out s-duration-150 s-cursor-pointer"
					}
				},
				"error-light-xs": {
					el: {
						root:
							"s-inline-flex s-items-center s-px-2 s-border s-border-transparent s-text-xs s-leading-relaxed s-font-medium s-rounded-md s-text-red-600 s-bg-red-100 hover:s-text-red-500 focus:s-outline-none focus:s-border-red-200 focus:s-shadow-outline-indigo active:s-bg-red-700 s-transition s-ease-in-out s-duration-150 s-cursor-pointer"
					}
				},
				"error-light-sm": {
					el: {
						root:
							"s-inline-flex s-items-center s-px-3 s-py-1 s-border s-border-transparent s-text-xs  s-leading-relaxed s-font-medium s-rounded-md s-text-red-600 s-bg-red-100 hover:s-text-red-500 focus:s-outline-none focus:s-border-red-200 focus:s-shadow-outline-indigo active:s-bg-red-700 s-transition s-ease-in-out s-duration-150 s-cursor-pointer"
					}
				},
				"error-light": {
					el: {
						root:
							"s-inline-flex s-items-center s-px-4 s-py-2 s-border s-border-transparent s-text-base s-leading-relaxed s-font-medium s-rounded-md s-text-red-600 s-bg-red-100 hover:s-text-red-500 focus:s-outline-none focus:s-border-red-200 focus:s-shadow-outline-indigo active:s-bg-red-700 s-transition s-ease-in-out s-duration-150 s-cursor-pointer"
					}
				},
				"error-light-lg": {
					el: {
						root:
							"s-inline-flex s-items-center s-px-5 s-py-2 s-border s-border-transparent s-text-xl  s-leading-relaxed s-font-medium s-rounded-lg s-text-red-600 s-bg-red-100 hover:s-text-red-500 focus:s-outline-none focus:s-border-red-200 focus:s-shadow-outline-indigo active:s-bg-red-700 s-transition s-ease-in-out s-duration-150 s-cursor-pointer"
					}
				},
				"error-light-xl": {
					el: {
						root:
							"s-inline-flex s-items-center s-px-6 s-py-2 s-border s-border-transparent s-text-2xl  s-leading-relaxed s-font-medium s-rounded-lg s-text-red-600 s-bg-red-100 hover:s-text-red-500 focus:s-outline-none focus:s-border-red-200 focus:s-shadow-outline-indigo active:s-bg-red-700 s-transition s-ease-in-out s-duration-150 s-cursor-pointer"
					}
				}
			},
			JSpinner: {
				default: {
					el: {
						circle: "s-inline-block s-w-4 s-h-4 s-border-t-2 s-rounded-full s-border-indigo-500",
						dots: "s-flex s-justify-center s-items-center s-w-auto s-h-auto",
						dotsItem: "s-w-4 s-h-4 s-rounded-full s-inline-block s-bg-indigo-500"
					}
				},
				indigo: {
					el: {
						circle: "inline-block s-w-4 s-h-4 s-border-t-2 s-rounded-full s-border-white",
						dots: "s-flex s-justify-center s-items-center s-w-auto s-h-auto",
						dotsItem: "s-w-4 s-h-4 s-mx-1 s-rounded-full s-bg-indigo-600 s-border-none"
					}
				},
				dark: {
					el: {
						circle: "inline-block s-w-4 s-h-4 s-border-t-2 s-rounded-full s-border-c1",
						dots: "flex flex-col justify-center items-center s-w-auto s-h-auto",
						dotsItem: "s-w-4 s-h-4 s-rounded-full inline-block bg-c1"
					}
				},
				"dark-large": {
					circle: "inline-block s-w-6 s-h-6 s-border-t-2 s-rounded-full s-border-c1",
					dots: "flex flex-col justify-center items-center s-w-auto s-h-auto",
					dotsItem: "s-w-6 s-h-6 s-rounded-full inline-block bg-c1"
				}
			},
			JSlider: {
				default: {
					el: {
						root: "slider-default"
					}
				}
			},
			JBox: {
				default: {
					el: {
						root: "s-block"
					}
				}
			},
			JFlex: {
				default: {
					el: {
						root: "s-flex"
					}
				}
			},
			JText: {
				default: {
					el: {
						root: "s-block"
					}
				}
			},
			JHeadline: {
				"default-lg": {
					el: {
						root: "s-text-lg s-font-semibold s-block s-w-full"
					}
				},
				default: {
					el: {
						root: "s-font-semibold  s-block s-w-full"
					}
				}
			},
			JLabel: {
				default: {
					el: {
						root: "s-block"
					}
				}
			}
		}
	}
}
